import { useEffect } from 'react';

type User = {
  name: string;
  phone: string;
  email?: string;
  about?: string;
  avatar?: string;
  tags?: string;
  forceUpdate?: boolean;
};
type Widget = {
  iconUrl: string;
  cssUrl: string;
  soundUrl: string;
  marginRight: number;
  marginLeft: number;
  marginBottom: number;
  hasIcon: boolean;
  hasSound: boolean;
  counter: string;
};

const goftino = {
  ready: false,
  queue: [] as VoidFunction[],
  element: null as HTMLElement | null,
  useInit() {
    useEffect(() => {
      const handler = () => {
        this.ready = true;
        this.queue.forEach((fn) => fn());
        this.queue = [];
        this.element = document.getElementById('goftino_w')!;
      };
      window.addEventListener('goftino_ready', handler);
      return () => {
        window.removeEventListener('goftino_ready', handler);
      };
    }, []);
  },
  run(fn: VoidFunction) {
    if (this.ready) {
      fn();
    } else {
      this.queue.push(fn);
    }
  },
  setUser(user: User) {
    this.run(function () {
      Goftino.setUser(user);
    });
  },
  open() {
    this.run(function () {
      Goftino.open();
    });
  },
  close() {
    this.run(function () {
      Goftino.close();
    });
  },
  toggle() {
    this.run(function () {
      Goftino.toggle();
    });
  },
  setWidget(v: Partial<Widget>) {
    this.run(() => {
      Goftino.setWidget(v);
    });
  },
};

export default goftino;
